import i18n from "@/lib/i18n";
import type {
  TicketStatus,
  TicketPriority,
  TicketCategory,
} from "./api";

// classes Tailwind (soft bg + texto) por status — estilo, não traduzível.
export const STATUS_TONE: Record<TicketStatus, string> = {
  open: "bg-info-soft text-info",
  in_progress: "bg-brand-500/15 text-brand-600",
  waiting_customer: "bg-warning-soft text-warning",
  resolved: "bg-success-soft text-success",
  closed: "bg-gray-100 text-ink-soft",
};

export const PRIORITY_TONE: Record<TicketPriority, string> = {
  low: "bg-gray-100 text-ink-soft",
  medium: "bg-info-soft text-info",
  high: "bg-warning-soft text-warning",
  urgent: "bg-red-50 text-red-600",
};

// Valores na ordem de exibição dos selects. Os rótulos vêm do i18n
// (support.category.* / support.priority.*) no ponto de uso.
export const CATEGORY_VALUES: TicketCategory[] = [
  "billing",
  "technical",
  "account",
  "feature_request",
  "other",
];

export const PRIORITY_VALUES: TicketPriority[] = [
  "low",
  "medium",
  "high",
  "urgent",
];

export function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString(i18n.language, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
